import languages from "@/configs/language";
import { useGeneralStore } from "@/stores/GeneralStore";

export const lang = (key) => {
  const choosedLanguage = useGeneralStore().$state.choosedLanguage;
  return languages[choosedLanguage][key];
};

export const getLang = () => {
  return useGeneralStore().$state.choosedLanguage;
};

export const isIndonesia = () => {
  return (
    useGeneralStore().$state.choosedLanguage.toLocaleLowerCase() == "indonesia"
  );
};
